import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { Resource } from "@/shared/types.ts";
import { CityEntity } from "@/features/city/type.ts";
import api from "@/shared/api";

type CreateCityRequest = {
  name: string;
  country: "KZ";
};

type EditCityRequest = {
  id: number;
} & CreateCityRequest;

type DeleteCity = {
  id: number;
};

export function useCreateCity() {
  const queryClient = useQueryClient();

  return useMutation<Resource<CityEntity>, Error, CreateCityRequest>({
    mutationFn: (data: CreateCityRequest) =>
      api.post("/api/v1/city", { json: data }).json(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["cities"] });
    },
  });
}

export function useEditCity() {
  const queryClient = useQueryClient();

  return useMutation<Resource<CityEntity>, Error, EditCityRequest>({
    mutationFn: (data: CreateCityRequest) =>
      api.put("/api/v1/city", { json: data }).json(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["cities"] });
    },
  });
}

export function useDeleteCity() {
  const queryClient = useQueryClient();

  return useMutation<Resource<CityEntity>, Error, DeleteCity>({
    mutationFn: (data: DeleteCity) =>
      api.delete(`/api/v1/city/${data.id}`, { json: data }).json(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["cities"] });
    },
  });
}

export function useCities() {
  return useQuery<Resource<CityEntity[]>>({
    queryKey: ["cities"],
    queryFn: () => api<Resource<CityEntity[]>>("/api/v1/city").json(),
    initialData: { data: [] } as { data: CityEntity[] },
  });
}
